import { useQuery } from 'react-query';
import { useMemo } from 'react';
import HudVoucherService from '../../services/hudVoucherService';
import { getHudVoucherStatsQueryKey } from './hooks.hudVoucherQueryKeys';

const PLACEHOLDER_DATA = {
  voucherId: null,
  newTenantEvents: {
    submittedCount: 0,
    notSubmittedCount: 0,
  },
  regularAssistance: {
    unitCount: null,
    requestedAmount: null,
    approvedAmount: null,
    caHudApprovedAmount: null,
    varianceAmount: null,
  },
  adjustments: {
    unitCount: null,
    requestedAmount: null,
    approvedAmount: null,
    caHudApprovedAmount: null,
    varianceAmount: null,
  },
  specialClaims: {
    unitCount: null,
    requestedAmount: null,
    approvedAmount: null,
    caHudApprovedAmount: null,
    varianceAmount: null,
  },
  repaymentAgreements: {
    unitCount: null,
    requestedAmount: null,
    approvedAmount: null,
    caHudApprovedAmount: null,
    varianceAmount: null,
  },
  miscellaneousAccounting: {
    requestedAmount: null,
    approvedAmount: null,
    caHudApprovedAmount: null,
    varianceAmount: null,
  },
  reviewAndSubmitVoucher: {
    totalRequestedAmount: null,
    totalApprovedAmount: null,
    totalCaHudApprovedAmount: null,
    varianceAmount: null,
  },
};

const HUD_VOUCHER_STATS_POLL_INTERVAL_MS = 10000;

const useHUDVoucherStatsQuery = ({
  options: baseOptions,
  hudVoucherId,
  organizationId,
  propertyId,
}) => {
  const options = useMemo(() => {
    const isReady = Boolean(organizationId && propertyId && hudVoucherId);
    const hasEnabledOverride = typeof baseOptions?.enabled === 'boolean';
    const isEnabled = hasEnabledOverride
      ? baseOptions.enabled && isReady
      : isReady;
    const hasRefetchIntervalOverride = Object.prototype.hasOwnProperty.call(
      baseOptions ?? {},
      'refetchInterval',
    );
    const refetchInterval = isEnabled
      ? hasRefetchIntervalOverride
        ? baseOptions.refetchInterval
        : HUD_VOUCHER_STATS_POLL_INTERVAL_MS
      : false;

    return {
      ...baseOptions,
      enabled: isEnabled,
      refetchInterval,
      refetchIntervalInBackground: true,
      refetchOnWindowFocus: false,
      retry: false,
      placeholderData: PLACEHOLDER_DATA,
    };
  }, [baseOptions, hudVoucherId, organizationId, propertyId]);

  return useQuery(
    getHudVoucherStatsQueryKey(organizationId, propertyId, hudVoucherId),
    async () => {
      const service = new HudVoucherService();
      return service.getHudVoucherStats(
        organizationId,
        propertyId,
        hudVoucherId,
      );
    },
    options,
  );
};

export default useHUDVoucherStatsQuery;
